import { createContext, ReactNode, useContext } from 'react';

// True only inside the affiliate workflow editor, which wraps its WorkflowEditor
// in the provider below. Every other host of the editor keeps the false default,
// so nothing outside the affiliate area changes.
const AffiliateWorkflowEditorContext = createContext<boolean>(false);

export const useIsAffiliateWorkflowEditor = (): boolean =>
  useContext(AffiliateWorkflowEditorContext);

interface AffiliateWorkflowEditorProviderProps {
  children: ReactNode;
}

export const AffiliateWorkflowEditorProvider = ({
  children,
}: AffiliateWorkflowEditorProviderProps) => (
  <AffiliateWorkflowEditorContext.Provider value>
    {children}
  </AffiliateWorkflowEditorContext.Provider>
);
